module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0007.jpg?v=ce3d7d8b";